<div class="tabsList" [class._verticalMode]="verticalMode">
    <ul class="tabsList-list">
        <li class="tabsList-item" *ngFor="let tab of tabs"
            [ngClass]="{_isSelected : tab.selected === true, _hasAlert: tab.withAlert === true }">
            <button type="button" class="tabsList-item-link grid-x align-middle" (click)="selectTab(tab)" [disabled]="tab.disabled">
                <div class="cell auto">
                    <i class="{{tab.faIcon}}" *ngIf="tab.faIcon"></i>
                    <span [i18n]="[{target: 'innerHTML', key: tab.tabTextKey, params: tab.tabTextParams}]"></span>
                </div>
            </button>
        </li>
    </ul>
</div>
<div class="tab-container" [class._verticalMode]="verticalMode">
    <ng-content></ng-content>
</div>

